<template>
  <div>
    <div class="container mt-3">
      <div class="mt-3">
        <h3 class="title mb-3">강사 통합 관리</h3>
      </div>

      <div class="class-manage-card p-3">
        <Form @submit="onSubmit" class="form">
          <table class="info">
            <tbody>
              <tr>
                <td class="w-20per txt-center label p-2" id="companyLabel">강사명 <span class="required">*</span></td>
                <td class="w-75per p-3">
                  <div class="w-25per d-inline-block">
                    <Field id="tutorName" name="tutorName" label="강사명">
                      <b-form-input v-model="tutorData.name" id="tutorName" type="text" placeholder="강사명을 입력해주세요"> </b-form-input>
                    </Field>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="w-20per txt-center label p-2" id="companyLabel">언어 <span class="required">*</span></td>
                <td class="w-75per p-3">
                  <Field id="tutorLanguage" name="tutorLanguage" label="언어선택">
                    <b-form-radio-group v-model="tutorData.languageIdx" id="tutorLanguage" name="tutorLanguage" :options="optionLanguage"> </b-form-radio-group>
                  </Field>
                </td>
              </tr>
              <tr>
                <td class="w-20per txt-center label p-2" id="companyLabel">성별<span class="required">*</span></td>
                <td class="w-75per p-3">
                  <div class="w-50per d-inline-block">
                    <Field id="tutorGender" name="tutorGender" label="언어선택">
                      <b-form-radio-group v-model="tutorData.gender" id="tutorGender" :options="optionGender"> </b-form-radio-group>
                    </Field>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="w-20per txt-center label p-2" id="companyLabel">프로필 사진 업로드</td>
                <td class="w-75per p-3">
                  <div class="w-70per mt-2">
                    <div class="d-flex align-items-center">
                      <div class="w-60per">
                        <Field ref="popupImageUrlRef" id="popupImageUrl" name="popupImageUrl" label="팝업 파일">
                          <input class="form-control" @change="fileChange" ref="popupImageUrlRef" type="file" name="popupImage" id="tutorImg" accept=".png, .jpg, .jpeg" />
                          <input type="hidden" />
                        </Field>
                      </div>
                    </div>
                    <div class="mt-2">※ jpg, png,jpeg 파일만 등록 가능</div>
                    <div class="mt-2">※ 사진은 가로, 세로 80px(픽셀) 에 맞춰서 자동 적용됩니다</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="w-20per txt-center label p-2" id="companyLabel">강사 소개 <span class="required">*</span></td>
                <td class="w-75per p-3">
                  <div class="w-60per d-inline-block">
                    <b-form-textarea v-model="tutorData.greetings" rows="3"></b-form-textarea>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="w-20per txt-center label p-2" id="companyLabel">해시태그</td>
                <td class="w-75per p-3">
                  <div class="w-60per d-inline-block box-wrapper">
                    <span class="innerBox" v-for="(item, index) in tags" :key="index">#{{ item }} <span style="cursor: pointer" @click="deleteTag(item)"> x</span></span>
                    <b-form-input id="tutorName" type="text" placeholder="엔터로 해시태그를 입력해주세요" @keyup.enter="enterInputHashtag"></b-form-input>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="w-20per txt-center label p-2" id="companyLabel">학력 <span class="required">*</span></td>
                <td class="w-75per p-3">
                  <div class="w-60per d-inline-block">
                    <b-form-textarea v-model="tutorData.education" rows="3"></b-form-textarea>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="w-20per txt-center label p-2" id="companyLabel">경력 <span class="required">*</span></td>
                <td class="w-75per p-3">
                  <div class="w-60per d-inline-block">
                    <b-form-textarea v-model="tutorData.workExperience" rows="5"></b-form-textarea>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </Form>
        <div class="txt-right mt-3">
          <div class="d-flex justify-content-end">
            <b-button variant="outline-primary" class="search-button me-2" @click="back">돌아가기</b-button>
            <b-button variant="primary" class="search-button" :disabled="btnLoading ? true : false" @click="onSubmit">등록</b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive } from '@vue/runtime-core';
import { useRouter } from 'vue-router';
import _ from 'lodash';
import { sugangTutorAddApi, fileUploadApi } from '@/api/integrateapi/index';
export default {
  setup() {
    const router = useRouter();
    const btnLoading = ref(false);
    const tags = reactive([]);
    const hashList = [];
    const optionLanguage = [
      { idx: 1, text: '영어', value: 1 },
      { idx: 2, text: '중국어/일본어', value: 2 },
    ];
    const optionGender = [
      { idx: 1, text: 'MALE', value: 'M' },
      { idx: 2, text: 'FEMALE', value: 'F' },
    ];
    const tutorData = {
      education: '',
      gender: '',
      greetings: '',
      hashtagList: [],
      languageIdx: '',
      name: '',
      photoUrl: '',
      workExperience: '',
    };
    const selectedLanguage = ref([]);
    const selectedGender = ref([]);
    const addTutor = () => {
      sugangTutorAddApi(tutorData)
        .then(resp => {
          const { success } = resp.data;
          if (success) {
            alert('강사 추가에 성공하였습니다.');
            router.back();
          } else {
            alert('강사 추가에 실패하였습니다.');
          }
        })
        .catch(error => {
          if (error.response) {
            alert('서버에 에러가 발생하였습니다.');
            // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            // 요청이 이루어 졌으나 응답을 받지 못했습니다.
            // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
            // Node.js의 http.ClientRequest 인스턴스입니다.
            console.log(error.request);
          } else {
            // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
            console.log('Error', error.message);
          }
          console.log(error.config);
        })
        .finally(() => {});
    };
    const onSubmit = async () => {
      if (tutorData.name == '' || tutorData.languageIdx == '' || tutorData.gender == '' || tutorData.education == '' || tutorData.workExperience == '') {
        alert('필수값을 입력해주세요');
        return;
      } else {
        setHashTag();
        addTutor();
      }
    };
    const enterInputHashtag = $event => {
      tags.push($event.target.value);
      $event.target.value = '';
    };
    const deleteTag = text => {
      let stringToRemove = text;
      for (let i = tags.length - 1; i >= 0; i--) {
        if (tags[i] === stringToRemove) {
          tags.splice(i, 1);
        }
      }
    };
    const setHashTag = () => {
      tags.forEach((el, index) => {
        hashList.push({ hashtag: el, sort: index });
      });
      tutorData.hashtagList = hashList;
    };

    const fileChange = e1 => {
      const file = e1.target.files[0];
      const frm = new FormData();
      frm.append('file', file);
      fileUploadApi(frm)
        .then(resp => {
          const { result } = resp.data;
          const { uploadUrl } = result;
          tutorData.photoUrl = uploadUrl;
        })
        .catch(error => {
          if (error.response) {
            alert('서버에 에러가 발생하였습니다.');
            // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            // 요청이 이루어 졌으나 응답을 받지 못했습니다.
            // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
            // Node.js의 http.ClientRequest 인스턴스입니다.
            console.log(error.request);
          } else {
            // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
            console.log('Error', error.message);
          }
          console.log(error.config);
        })
        .finally(() => {});
    };
    const back = () => {
      router.back();
    };

    return {
      onSubmit,
      tags,
      btnLoading,
      back,
      optionLanguage,
      optionGender,
      addTutor,
      tutorData,
      selectedLanguage,
      selectedGender,
      enterInputHashtag,
      deleteTag,
      setHashTag,
      fileChange,
    };
  },
};
</script>

<style>
.box-wrapper {
  border: 1px solid #ced4da;
  padding: 10px;
  border-radius: 4px;
  display: flex !important;
  flex-wrap: wrap;
  gap: 5px;
}
#tutorName {
  width: 230px;
  padding: 5px;
}
.innerBox {
  font-size: 15px;
  height: 35px;
  padding: 5px;
  box-sizing: border-box;
  /* background-color: rgba(29, 212, 105, 0.719); */
  border: solid;
  border-color: rgba(138, 184, 237, 0.719);
  color: rgb(72, 179, 255);
  /* font-weight: 700; */
  border-radius: 0.3rem;
}
</style>
